import React from "react";

const Home = () => {
  return (
    <div>
      <h1>Profile Page</h1>
    </div>
  );
};

export default Home;
